module.exports = __webpack_public_path__ + "img/Summary_old.66df0620.svg";